// extracted by mini-css-extract-plugin
module.exports = {"jobRanking":"jobRanking"};